import dynamic from 'next/dynamic';

const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
  loading: () => <div style={{ height: 120 }} />
});

interface LottieAnimationProps {
  loop?: boolean;
  autoplay?: boolean;
  animationData: TypeAny;
  styles: TypeAny;
}

function LottieAnimation({
  loop = false,
  autoplay = true,
  animationData,
  styles
}: LottieAnimationProps) {
  return (
    <div>
      <Lottie autoplay={autoplay} loop={loop} animationData={animationData} style={styles} />
    </div>
  );
}

export default LottieAnimation;
